import { GroupResultProps } from "api/types";
import { Document, Font, Page, Text, View } from "@react-pdf/renderer";
import { AssignmentHeader } from "../IndividualResultPDF/AssignmentPage";
import {
	CurriculumHeader,
	CurriculumResultsContent,
} from "../IndividualResultPDF/CurriculumPage";
import { GroupAssignmentResultsContent } from "../IndividualResultPDF/AssignmentPage/GroupAssignmentResultsContent";
import {
	AppendixContent,
	AppendixHeader,
} from "../IndividualResultPDF/AppendixPage";
import {
	CommentContent,
	CommentHeader,
} from "../IndividualResultPDF/CommentPage";

Font.register({
	src: `/fonts/PublicSans-Medium.ttf`,
	family: "Public Sans",
	fontWeight: "medium",
});

Font.register({
	family: "Inter",
	fonts: [
		{
			src: `/fonts/Inter-Regular.ttf`,
		},
		{
			src: `/fonts/Inter-Medium.ttf`,
			fontWeight: "medium",
		},
		{
			src: `/fonts/Inter-SemiBold.ttf`,
			fontWeight: "semibold",
		},
		{
			src: `/fonts/Inter-Bold.ttf`,
			fontWeight: "bold",
		},
	],
});

Font.registerHyphenationCallback((word) => [word]);

export interface DocumentProps {
	data: GroupResultProps;
}

export const GroupResultTemplate: React.FC<DocumentProps> = ({ data }) => {
	if (data) {
		return (
			<Document title={data.name + " Academic Result"}>
				{/* 794x1123 is the page size of the high fidelity */}
				<Page size={[794, 1123]}>
					<AssignmentHeader
						name={"Group: " + data.name}
						yearLevel={data.yearLevel}
						date={data.date}
					/>
					<GroupAssignmentResultsContent data={data.groupAssignmentResults} />
				</Page>
				<Page size={[794, 1123]}>
					<CurriculumHeader />
					<CurriculumResultsContent data={data.curriculumResults} />
				</Page>
				<Page size={[794, 1123]}>
					<CommentHeader />
					<CommentContent data={data.comments} name={""} />
				</Page>
				<Page size={[794, 1123]}>
					<AppendixHeader />
					<AppendixContent data={data.groupAssignmentResults} />
				</Page>
			</Document>
		);
	} else {
		return (
			<Document>
				<Page size="A4">
					<View>
						<Text>This Pdf could not be generated</Text>
					</View>
				</Page>
			</Document>
		);
	}
};
